import type { PollContentObjectDetail, PollContentObjectList } from 'models';
import { useMutation } from 'query';
import { deletePoll } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeletePollContentObject = { contentObject: PollContentObjectDetail | PollContentObjectList };

export const useDeletePollContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeletePollContentObject, DeletePollContentObject>({
    async mutationFn(object) {
      await deletePoll({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
